export class EndOfFile {}
